import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { ZdlakeCityDestinations } from '../../models';

export const featureAdapter: EntityAdapter<ZdlakeCityDestinations> =
  createEntityAdapter<ZdlakeCityDestinations>({
    selectId: (model) => model.city_name,
  });

export interface State extends EntityState<ZdlakeCityDestinations> {
  isLoading?: boolean;
  error?: any;
}

export const initialState: State = featureAdapter.getInitialState({
  isLoading: false,
  error: null,
});
